import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal, Tooltip, OverlayTrigger, } from 'react-bootstrap';
import { Link } from "react-router-dom";
import DatePicker, { DateObject } from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import $ from 'jquery';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Followup_Report = ({ show, onClose, data, refresh }) => {
    
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    // format date display
    const formatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    function convert24to12(time24) {
        if (time24) {
            const [hourStr, minute, second] = time24.split(':');
            let hour = parseInt(hourStr, 10);

            // Determine AM or PM
            const ampm = hour >= 12 ? 'PM' : 'AM';

            // Convert hour from 24-hour to 12-hour format
            hour = hour % 12;
            if (hour === 0) hour = 12; // the hour '0' should be '12'

            // Return formatted string without seconds (optional)
            return `${hour}:${minute} ${ampm}`;
        } else {
            return '';
        }
    };

    const [score, setScore] = useState(0);
    const [conversation, setConversation] = useState('');

    const [errors, setErrors] = useState({});
    const validate = () => {
        const newErrors = {};
        if (!conversation) {
            newErrors.conversation = "This Field is Required.";
        }

        return newErrors;
    };

    const user_id = parseInt(localStorage.getItem("user_id"), 10);
    
    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const postData = { 
            conversation: conversation,
            appointment_score: score,
            updated_by: user_id,
        };

        axios.put(`${baseURL}/appointment/complete/${data.sno}`, postData)
            .then(response => {
                onClose();
                refresh();
                toast.success("Appointment Completed Successfully!");
            }).catch(error => {
                onClose();
                console.log(error);
                toast.error("Appointment Completion Failed");
            });
    };

    return (

        <Modal show={show} size="lg">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Appointment Completed</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-2'>
                            <label className='text-gray-800 font-w500 fs-7'>Lead</label>
                            <label className='text-black fs-6 font-w500'>{data.lead_name}</label>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-2'>
                            <label className='text-gray-800 font-w500 fs-7'>Mail ID</label>
                            <label className='text-black fs-6 font-w500'>{data.lead_email ? data.lead_email : '-'}</label>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-2'>
                            <label className='text-gray-800 font-w500 fs-7'>Mobile No</label>
                            <label className='text-black fs-6 font-w500'>{data.lead_mobile}</label>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-2'>
                            <label className='text-gray-800 font-w500 fs-7'>Appointment Date & Time</label>
                            <label className='text-black fs-6 font-w500'>
                                <span className='text-primary'>{formatDate(data.appointment_date)}</span>
                                <span className='me-1 ms-1'>/</span>
                                <span className='text-danger'>{convert24to12(data.appointment_time)}</span>
                            </label>
                        </div>
                        <div className="col-lg-12 mb-2">

                            <div className='col-lg-6 mb-2'>
                                <div className='row'>
                                    <div className="col-lg-12 d-flex align-items-center gap-3 mb-2">
                                        <div className="d-flex">
                                            <input
                                                className="form-check-input me-1"
                                                type="radio"
                                                name="size_type"
                                                value="option1"
                                                onChange={() => {
                                                    setScore(1);
                                                }}
                                            />
                                            <label className="form-check-label fs-6 text-black font-w400">
                                                <span>Positive</span>
                                                <span>(+1)</span>
                                            </label>
                                        </div>

                                        <div className="d-flex">
                                            <input
                                                className="form-check-input me-1"
                                                type="radio"
                                                name="size_type"
                                                value="option2"
                                                onChange={() => {
                                                    setScore(-1);
                                                }}
                                            />
                                            <label className="form-check-label fs-6 text-black font-w400">
                                                <span>Negative</span>
                                                <span>(-1)</span>
                                            </label>
                                        </div>

                                        <div className="d-flex">
                                            <input
                                                className="form-check-input me-1"
                                                type="radio"
                                                name="size_type"
                                                value="option2"
                                                onChange={() => {
                                                    setScore(0);
                                                }}
                                                defaultChecked
                                            />
                                            <label className="form-check-label fs-6 text-black font-w400">
                                                <span>Neutral</span>
                                                <span>(0)</span>
                                            </label>
                                        </div>
                                    </div>
                                    {/* <div className="col-lg-12 mb-2">
                                                <label className="text-black font-w500 fs-7">Conversation</label>
                                                <textarea rows={8} className="form-control" name="comment" placeholder="Conversation" defaultValue={"-"} />
                                            </div> */}
                                </div>
                            </div>
                            <div className="col-lg-12">
                                <label className="text-black font-w500 fs-7">Conversation<span className="required">*</span></label>
                                <textarea rows={8} className="form-control" name="comment" placeholder="Conversation" 
                                    maxLength={100}
                                    value={conversation} 
                                    onChange={(e) => setConversation(e.target.value)} 
                                />
                                {errors.conversation && <div className="text-danger fs-8 mt-1">{errors.conversation}</div>}
                            </div>

                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit} >Appointment Completed <i className="fas fa-angle-double-right ms-2"></i></Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default Followup_Report;
